export const PH_EVENT_USER_VIEWED_SETUPONBOARDING_DOWNLOAD_APP =
  "user_viewed_setuponboarding_download_app";

export const PH_EVENT_USER_VIEWED_DATA_DELETION_SEARCH_LOADING =
  "user_viewed_data_deletion_search_loading";
export const PH_EVENT_USER_VIEWED_DATA_DELETION_PHONE_VERIFICATION =
  "user_viewed_data_deletion_phone_verification";
export const PH_EVENT_USER_VIEWED_DATA_DELETION_SEARCH_NAME_FORM =
  "user_viewed_data_deletion_search_name_form";
export const PH_EVENT_USER_VIEWED_DATA_DELETION_SEARCH_AGE_FORM =
  "user_viewed_data_deletion_search_age_form";
export const PH_EVENT_USER_VIEWED_DATA_DELETION_SEARCH_STATE_FORM =
  "user_viewed_data_deletion_search_state_form";
export const PH_EVENT_USER_SUBMITTED_DATA_DELETION_SEARCH_NAME_FORM =
  "user_submitted_data_deletion_search_name_form";
export const PH_EVENT_USER_SUBMITTED_DATA_DELETION_SEARCH_AGE_FORM =
  "user_submitted_data_deletion_search_age_form";
export const PH_EVENT_USER_SUBMITTED_DATA_DELETION_SEARCH_STATE_FORM =
  "user_submitted_data_deletion_search_state_form";
export const PH_EVENT_USER_VIEWED_DATA_DELETION_SEARCH_RESULTS =
  "user_viewed_data_deletion_search_results";
export const PH_EVENT_USER_VIEWED_DATA_DELETION_NO_RESULTS =
  "user_viewed_data_deletion_no_results";
export const PH_EVENT_USER_CLICKED_DATA_DELETION_NOT_ME_BUTTON =
  "user_clicked_data_deletion_not_me_button";
export const PH_EVENT_USER_CLICKED_DATA_DELETION_NETWORK_SKIP_BUTTON =
  "user_clicked_data_deletion_network_skip_button";
export const PH_EVENT_USER_CLICKED_DATA_DELETION_NETWORK_VIEW_FULL_REPORT_BUTTON =
  "user_clicked_data_deletion_network_view_full_report_button";
export const PH_EVENT_USER_VIEWED_DATA_DELETION_NETWORK =
  "user_viewed_data_deletion_network";
export const PH_EVENT_USER_VIEWED_DATA_DELETION_THREAT_LEVEL =
  "user_viewed_data_delete_threat_level";
export const PH_EVENT_USER_CLICKED_DATA_DELETION_SEARCH_RESULTS_CONTINUE_BUTTON =
  "user_clicked_data_deletion_search_results_continue_button";
export const PH_EVENT_USER_CLICKED_DATA_DELETION_SETUP_ACCOUNT_BUTTON =
  "user_clicked_data_deletion_setup_account_button";
export const PH_EVENT_USER_VIEWED_DATA_DELETION_SIGNUP_SUCCESS_SCREEN =
  "user_viewed_data_deletion_signup_success_screen";
export const PH_EVENT_USER_AGREED_TO_DATA_DELETION_AGENCY_AGREEMENT =
  "user_agreed_to_data_deletion_agency_agreement";
export const PH_EVENT_USER_CLICKED_DATA_DELETION_STATUS_IN_HOME_PAGE_TILE =
  "user_clicked_data_deletion_status_in_home_page_tile";
export const PH_EVENT_USER_ENTERED_DATA_SCAN = "user_entered_data_scan";
export const PH_EVENT_HOME_ACTION = "user_clicked_dashboardactionitem";
export const PH_EVENT_USER_CLICKED_SIGN_UP_NO_WASM =
  "user_clicked_sign_up_no_wasm";
export const PH_EVENT_REFERRAL_SENT = "referral_sent";

// data scan events
export const PH_EVENT_USER_VIEWED_DATA_SCAN_SPYCLOUD_DATA =
  "user_viewed_data_scan_spycloud_data";
export const PH_EVENT_VIEWED_DATA_SCAN_OTP_VERIFICATION_FAILED =
  "user_viewed_data_scan_otp_verification_failed";

// data removal events
export const PH_EVENT_DATA_REMOVAL_USER_CLICKED_MARK_DONE =
  "user_clicked_data_removal_screen_action_required_broker_mark_as_removed_button";
export const PH_EVENT_DATA_REMOVAL_USER_CLICKED_MARK_DONE_CONFIRMATION =
  "user_clicked_data_removal_screen_action_required_broker_mark_as_removed_button_confirmation";

export const PH_EVENT_USER_VIEWED_DD_SUBMISSION_FORM =
  "user_viewed_data_deletion_submission_form";
export const PH_EVENT_USER_SUBMITTED_DD_SUBMISSION_FORM =
  "user_submitted_data_deletion_submission_form";
export const PH_EVENT_ENROLLMENT_DATA_AUTOFILL_ACCURACY =
  "enrollment_data_autofill_accuracy";

export const PH_EVENT_USER_SUBMITTED_DD_SCAN_EMAIL_MODAL_CAPTURE =
  "user_submitted_data_deletion_scan_email_modal_capture";
export const PH_EVENT_USER_VIEWED_DD_SCAN_EMAIL_MODAL =
  "user_viewed_data_delete_scan_email_modal";

// Intermediate checkout screen events
export const PH_EVENT_USER_VIEWED_INTERMEDIATE_CHECKOUT_SCREEN =
  "user_viewed_intermediate_checkout_screen";
export const PH_EVENT_USER_CLICKED_CONTINUE_ON_INTERMEDIATE_CHECKOUT_SCREEN =
  "user_clicked_continue_on_intermediate_checkout_screen";

// Intermediate checkout questions screen events
export const PH_EVENT_USER_VIEWED_INTERMEDIATE_QUESTION_SCREEN =
  "user_viewed_intermediate_question_screen";
export const PH_EVENT_USER_CLICKED_NEXT_ON_INTERMEDIATE_QUESTION_SCREEN =
  "user_clicked_next_on_intermediate_question_screen";
export const PH_EVENT_USER_SKIPPED_INTERMEDIATE_QUESTION_SCREEN =
  "user_skipped_intermediate_question_screen";

// Email breach search events
export const PH_EVENT_EMAIL_BREACH_SEARCH_STARTED =
  "email_breach_search_started";
export const PH_EVENT_EMAIL_BREACH_RESULTS_VIEWED =
  "email_breach_results_viewed";
export const PH_EVENT_EMAIL_BREACH_IDENTITY_REVEALED =
  "email_breach_identity_revealed";
export const PH_EVENT_EMAIL_BREACH_IDENTITY_MASKED =
  "email_breach_identity_masked";

/* eSims Events */
export const PH_SCREEN_EVENT_ESIM_ONBOARDING_INTRO_SCREEN =
  "eSim_onboarding_intro_screen";
export const PH_SCREEN_EVENT_ESIM_ONBOARDING_COVERAGE_SCREEN =
  "eSim_onboarding_coverage_screen";
export const PH_SCREEN_EVENT_ESIM_ONBOARDING_COMPATIBILITY_SCREEN =
  "eSim_onboarding_compatibility_screen";
export const PH_SCREEN_EVENT_ESIM_ONBOARDING_INCOMPATIBILITY_SCREEN =
  "eSim_onboarding_compatibility_screen";
export const PH_SCREEN_EVENT_ESIM_ONBOARDING_PAYMENT_SCREEN =
  "eSim_onboarding_payment_screen";
export const PH_SCREEN_EVENT_ESIM_ONBOARDING_AREA_CODE_SCREEN =
  "eSim_onboarding_area_code_screen";
export const PH_SCREEN_EVENT_ESIM_ACTIVATING_ESIM_SCREEN =
  "eSim_onboarding_esim_activating_screen";
export const PH_SCREEN_EVENT_ESIM_COMPLETE_ESIM_SCREEN =
  "eSim_onboarding_esim_complete_screen";
export const PH_EVENT_ESIM_USER_CHANGED_ZIP_CODE = "eSim_user_changed_zipcode";

/* Feature flags */
export const PH_EVENT_CLOAKED_AUTH_TOTP_MFA_ENABLED = "cloaked-auth-mfa-totp";
export const PH_FEATURE_FLAG_DATA_DELETION_IN_APP_SEARCH = "dd_in_app_search";
export const PH_FEATURE_FLAG_DD_SCHEDULE_CALL = "dd_schedule_call";
export const PH_FEATURE_FLAG_DD_EMAIL_CAPTURE_MODAL = "dd_email_capture_modal";
export const PH_FEATURE_FLAG_SCAN_RESULTS_FEEDBACK_BUTTONS =
  "scan_results_feedback_buttons";
export const PH_FEATURE_FLAG_SCAN_NETWORK_VISUALIZATION =
  "scan_network_visualization";
export const PH_FEATURE_FLAG_CHECKOUT_FIXED_CTA = "checkout-fixed-cta";
export const PH_FEATURE_FLAG_SCAN_IDENTITIES_COUNTER = "scan_exposures_counter";
export const PH_FEATURE_FLAG_AI_OPERATOR = "operator-enabled";
export const PH_FEATURE_FLAG_AUTO_CLOAKING = "autocloaking-operator-enabled";
export const PH_FEATURE_FLAG_KILLSWITCH_TURNSTILE_CAPTCHA =
  "killswitch-turnstile-captcha";

// bulk plans
export const PH_EVENT_BULK_PLAN_USER_CLICKED_PLAN_TYPE =
  "user_clicked_subscription_type_post_payment_bulk_plan";
export const PH_EVENT_BULK_PLAN_USER_CLICKED_INVITES =
  "user_clicked_invites_remaining_post_payment_bulk_plan";

// ai data removal operator
export const PH_EVENT_DATA_REMOVAL_USER_CLICKED_OPERATOR_START =
  "user_clicked_operator_start_removal_button";
export const PH_EVENT_DATA_REMOVAL_USER_CLICKED_OPERATOR_OPEN_EXTENSION =
  "user_clicked_operator_open_extension";
export const PH_EVENT_OPERATOR_EXTENSION_MODAL_USER_CLICKED_INSTALL_CLOAKED_EXTENSION =
  "operator_extension_modal_user_clicked_install_cloaked_extension";
export const PH_EVENT_OPERATOR_EXTENSION_MODAL_USER_CLICKED_VIEW_MANUAL_REMOVAL_STEPS =
  "operator_extension_modal_user_clicked_view_manual_removal_steps";

// app download event
export const PH_EVENT_USER_CLICKED_DOWNLOAD_APP = "user_clicked_download_app";

// Top of Funnel Experiment
export const PH_FEATURE_FLAG_TOP_OF_FUNNEL_EXPERIMENT =
  "top-of-funnel-experiment";

// Download App Experiment
export const PH_FEATURE_FLAG_DOWNLOAD_APP_EXPERIMENT =
  "download-app-experiment";

// Data Deletion Improvement
export const PH_FEATURE_FLAG_DATA_DELETION_IMPROVEMENT =
  "data_deletion_improvement";

// Checkout Minimal Copy Mode
export const PH_FEATURE_FLAG_CHECKOUT_MINIMAL_COPY_MODE =
  "checkout-minimal-copy-mode";

// Checkout New Baseline Experiment
export const PH_FEATURE_FLAG_CHECKOUT_NEW_BASELINE = "checkout-new-baseline";

// Checkout Trust Badges Banner
export const PH_FEATURE_FLAG_CHECKOUT_TRUST_BADGES = "checkout-trust-badges";

// Checkout Promo Banner Privacy Week
export const PH_FEATURE_FLAG_CHECKOUT_PRIVACY_WEEK_BANNER_COPY =
  "checkout-privacy-week-banner-copy";

// Checkout Reduced Visual Clutter
export const PH_FEATURE_FLAG_CHECKOUT_REDUCED_VISUAL_CLUTTER =
  "checkout_reduced_visual_clutter";

// Checkout POA Agreement Experiment
export const PH_FEATURE_FLAG_CHECKOUT_POA_AGREEMENT = "checkout-poa-agreement";

// Personalized Questionnaire Flow Events
// Three-Question Flow Events
export const PH_EVENT_PERSONALIZED_THREE_QUESTIONS_SPAM_CALLS_VIEWED =
  "personalized_three_questions_spam_calls_viewed";
export const PH_EVENT_PERSONALIZED_THREE_QUESTIONS_SPAM_CALLS_ANSWERED =
  "personalized_three_questions_spam_calls_answered";
export const PH_EVENT_PERSONALIZED_THREE_QUESTIONS_SPAM_CALLS_SKIPPED =
  "personalized_three_questions_spam_calls_skipped";

export const PH_EVENT_PERSONALIZED_THREE_QUESTIONS_SERVICES_USED_VIEWED =
  "personalized_three_questions_services_used_viewed";
export const PH_EVENT_PERSONALIZED_THREE_QUESTIONS_SERVICES_USED_ANSWERED =
  "personalized_three_questions_services_used_answered";
export const PH_EVENT_PERSONALIZED_THREE_QUESTIONS_SERVICES_USED_SKIPPED =
  "personalized_three_questions_services_used_skipped";

export const PH_EVENT_PERSONALIZED_THREE_QUESTIONS_SECURITY_CONCERNS_VIEWED =
  "personalized_three_questions_security_concerns_viewed";
export const PH_EVENT_PERSONALIZED_THREE_QUESTIONS_SECURITY_CONCERNS_ANSWERED =
  "personalized_three_questions_security_concerns_answered";
export const PH_EVENT_PERSONALIZED_THREE_QUESTIONS_SECURITY_CONCERNS_SKIPPED =
  "personalized_three_questions_security_concerns_skipped";

// One-Question Flow Events
export const PH_EVENT_PERSONALIZED_ONE_QUESTION_PRIVACY_THREAT_VIEWED =
  "personalized_one_question_privacy_threat_viewed";
export const PH_EVENT_PERSONALIZED_ONE_QUESTION_PRIVACY_THREAT_ANSWERED =
  "personalized_one_question_privacy_threat_answered";
export const PH_EVENT_PERSONALIZED_ONE_QUESTION_PRIVACY_THREAT_SKIPPED =
  "personalized_one_question_privacy_threat_skipped";

// Common Flow Events
export const PH_EVENT_PERSONALIZED_QUESTIONS_LOADING_VIEWED =
  "personalized_questions_loading_viewed";
export const PH_EVENT_PERSONALIZED_QUESTIONS_CHECKOUT_VIEWED =
  "personalized_questions_checkout_viewed";
